/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClaimSearchResult
 */
export interface ClaimSearchResult {
    /**
     * 
     * @type {string}
     * @memberof ClaimSearchResult
     */
    claimNumber: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimSearchResult
     */
    lossLocation: string | null;
    /**
     * 
     * @type {string}
     * @memberof ClaimSearchResult
     */
    insured: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimSearchResult
     */
    insurer: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimSearchResult
     */
    presentPosition: string;
    /**
     * 
     * @type {Date}
     * @memberof ClaimSearchResult
     */
    dateOfLoss: Date;
    /**
     * 
     * @type {string}
     * @memberof ClaimSearchResult
     */
    broker: string;
    /**
     * 
     * @type {string}
     * @memberof ClaimSearchResult
     */
    customerReference: string | null;
    /**
     * 
     * @type {number}
     * @memberof ClaimSearchResult
     */
    totalReserves: number;
    /**
     * 
     * @type {string}
     * @memberof ClaimSearchResult
     */
    currency: string;
}

/**
 * Check if a given object implements the ClaimSearchResult interface.
 */
export function instanceOfClaimSearchResult(value: object): value is ClaimSearchResult {
    if (!('claimNumber' in value) || value['claimNumber'] === undefined) return false;
    if (!('lossLocation' in value) || value['lossLocation'] === undefined) return false;
    if (!('insured' in value) || value['insured'] === undefined) return false;
    if (!('insurer' in value) || value['insurer'] === undefined) return false;
    if (!('presentPosition' in value) || value['presentPosition'] === undefined) return false;
    if (!('dateOfLoss' in value) || value['dateOfLoss'] === undefined) return false;
    if (!('broker' in value) || value['broker'] === undefined) return false;
    if (!('customerReference' in value) || value['customerReference'] === undefined) return false;
    if (!('totalReserves' in value) || value['totalReserves'] === undefined) return false;
    if (!('currency' in value) || value['currency'] === undefined) return false;
    return true;
}

export function ClaimSearchResultFromJSON(json: any): ClaimSearchResult {
    return ClaimSearchResultFromJSONTyped(json, false);
}

export function ClaimSearchResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClaimSearchResult {
    if (json == null) {
        return json;
    }
    return {
        
        'claimNumber': json['claimNumber'],
        'lossLocation': json['lossLocation'],
        'insured': json['insured'],
        'insurer': json['insurer'],
        'presentPosition': json['presentPosition'],
        'dateOfLoss': (new Date(json['dateOfLoss'])),
        'broker': json['broker'],
        'customerReference': json['customerReference'],
        'totalReserves': json['totalReserves'],
        'currency': json['currency'],
    };
}

export function ClaimSearchResultToJSON(value?: ClaimSearchResult | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'claimNumber': value['claimNumber'],
        'lossLocation': value['lossLocation'],
        'insured': value['insured'],
        'insurer': value['insurer'],
        'presentPosition': value['presentPosition'],
        'dateOfLoss': ((value['dateOfLoss']).toISOString().substring(0,10)),
        'broker': value['broker'],
        'customerReference': value['customerReference'],
        'totalReserves': value['totalReserves'],
        'currency': value['currency'],
    };
}

